import React from 'react';
import { AttachmentBlockContent, Block } from '../types';
import { RefreshLightIcon, UserRegularIcon } from 'src/monet/icons';
import { ControlPanelActionButton } from '../components/control-panel/action-button';
import { ToggleBlockCaption } from '../components/toggle-block-caption';
import { TogglePersonalContent } from '../components/toggle-personal-content';

type Props = {
  block: Block;
  onReplaceBlock: () => void;
};

export const EditAttachmentControlPanelContent = ({ block, onReplaceBlock }: Props) => {
  const blockContent = block.content as AttachmentBlockContent;
  const contentObject = {
    file_url: blockContent.url,
    file_content_type: blockContent?.file?.type || blockContent?.contentType || '',
    name: blockContent?.file?.name || blockContent?.metadata?.name || '',
  };
  return (
    <>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col'>
          <ToggleBlockCaption block={block} />
          <TogglePersonalContent
            block={block}
            icon={<UserRegularIcon className='shrink-0' />}
            contentObject={contentObject}
          />
          <ControlPanelActionButton label='Replace file' iconComponent={RefreshLightIcon} onClick={onReplaceBlock} />
        </div>
      </div>
    </>
  );
};
